import { render, staticRenderFns } from "./header-list.vue?vue&type=template&id=18579bb7&"
import script from "./header-list.vue?vue&type=script&lang=js&"
export * from "./header-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports